import type { DeliveryGroupStopDraft } from './deliveryGroupTypes';
import {
  type ExecutionLockRouteContext,
  type StopExecutionLockInput,
  type StopExecutionState,
  canDeleteStopByExecutionState,
  canReorderStopByExecutionState,
  classifyStopExecutionState,
  isRouteInTransitExecution,
  isStopTopologyLocked,
  stopExecutionStateLabel
} from './executionTopologyLock';

export type RouteExecutionLockContext = ExecutionLockRouteContext;

export { StopExecutionState, stopExecutionStateLabel, isRouteInTransitExecution };

export function isRouteInTransit(ctx: RouteExecutionLockContext): boolean {
  return isRouteInTransitExecution(ctx);
}

export function isStopExecutionLocked(
  stop: StopExecutionLockInput,
  ctx?: RouteExecutionLockContext,
  allStops?: StopExecutionLockInput[]
): boolean {
  const state = classifyStopExecutionState(stop, ctx ?? {}, allStops);
  return isStopTopologyLocked(state);
}

export function resolveStopExecutionState(
  stop: StopExecutionLockInput,
  ctx?: RouteExecutionLockContext,
  allStops?: StopExecutionLockInput[]
): StopExecutionState {
  return classifyStopExecutionState(stop, ctx ?? {}, allStops);
}

export function stopMutationWarning(
  stop: StopExecutionLockInput,
  ctx?: RouteExecutionLockContext,
  allStops?: StopExecutionLockInput[]
): string | null {
  const state = resolveStopExecutionState(stop, ctx, allStops);
  if (state === 'COMPLETED') {
    return 'Точка уже выполнена — изменения могут повлиять на историю исполнения';
  }
  if (state === 'CURRENT') {
    return 'Точка в исполнении — доступны только контактные поля';
  }
  return null;
}

export function canDeleteStop(
  stop: StopExecutionLockInput,
  ctx?: RouteExecutionLockContext,
  allStops?: StopExecutionLockInput[]
): boolean {
  const state = resolveStopExecutionState(stop, ctx, allStops);
  return canDeleteStopByExecutionState(state);
}

export function canReorderStop(
  stop: StopExecutionLockInput,
  ctx?: RouteExecutionLockContext,
  allStops?: StopExecutionLockInput[]
): boolean {
  const state = resolveStopExecutionState(stop, ctx, allStops);
  return canReorderStopByExecutionState(state);
}

/** @deprecated use stop.lockState from projection hydration */
export function isStopCompleted(
  stop: Pick<DeliveryGroupStopDraft, 'lockState' | 'isCompleted'>
): boolean {
  if (stop.lockState === 'COMPLETED') return true;
  return stop.isCompleted === true;
}
